import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbItems from "../../components/BreadcrumbItems";
import Devices from "../common/DevicesTable";
import { AutoComplete, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { SET_SELECTED_DEVICE } from "../../redux/actions/dashboardActions";
import AdminDevicesList from "./AdminDevicesList";
import { notifyUser } from "../../utils/notifyUser";
import axiosLLInstance from "../../utils/axiosLLInstance";
import { search } from "../Dashboard/icons";

export default function AdminDevices() {
  const { adminId, fleetId } = useParams();
  const fleetUser = useSelector((state) => state.users.fleetUser);
  const [searchQuery, setSearchQuery] = useState("");
  const [lastQuery, setLastQuery] = useState("");
  const [options, setOptions] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSearch = () => {
    if (lastQuery !== searchQuery.trim()) {
      setLastQuery(searchQuery.trim());
      searchDevice(searchQuery);
    }
  };

  const searchDevice = async (value) => {
    try {
      const { data } = await axiosLLInstance.get(
        "/devices/search_within_fleet",
        {
          params: {
            id: fleetId,
            imei: value,
          },
        }
      );
      if (!data.length) {
        notifyUser({
          message: "No Match Found",
          type: "warning",
        });
        setOptions([]);
        return;
      }
      const options = data.map((device) => ({
        label: device.imei,
        value: JSON.stringify(device),
      }));
      setOptions(options);
    } catch (error) {
      console.error("Error fetching device", error);
    }
  };

  const onSelect = (device) => {
    const selectedDevice = JSON.parse(device);
    dispatch(SET_SELECTED_DEVICE(selectedDevice));
    navigate(`/dashboard/devices-analytics/${selectedDevice.imei}`);
  };

  const handleChange = (value) => {
    if (!value.trim()) {
      setOptions([]);
      setSearchQuery("");
      setLastQuery("");
      return;
    }
    setSearchQuery(value);
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <BreadcrumbItems
          items={[
            { title: `Manage Admins`, to: `/admins` },
            { title: "Fleet", to: `/admins/${adminId}/fleets` },
            { title: "Devices" },
          ]}
        />
        <div className="search-adminBox flex items-center justify-between w-32rem]">
          <AutoComplete
            className="h-12 border-gray-200 hover:border-gray-200 focus:border-gray-200 focus-within:border-gray-200 focus-within:shadow-none"
            onChange={handleChange}
            options={options}
            onSelect={onSelect}
          >
            <Input
              size="large"
              className="h-12 border-gray-200 hover:border-gray-200 focus:border-gray-200 focus-within:border-gray-200 focus-within:shadow-none"
              placeholder="Search IMEI"
              prefix={
                <img src={search} alt="search icon" onClick={handleSearch} />
              }
            />
          </AutoComplete>
        </div>
      </div>
      <div className="mt-12">
        <AdminDevicesList
          fleetId={fleetId}
          userId={fleetUser ? fleetUser.id : null}
        />
      </div>
    </>
  );
}
